import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../../services/api';
import { Save, ShieldCheck } from 'lucide-react';

const fetchConfig = async () => (await api.get('/agenda/config')).data.data;
const updateConfig = async (data) => (await api.put('/agenda/config', data)).data.data;

export default function ConfiguracaoAgenda() {
  const queryClient = useQueryClient();
  const { register, handleSubmit, reset } = useForm();

  const { data: config, isLoading } = useQuery({
    queryKey: ['agendaConfig'],
    queryFn: fetchConfig
  });

  const mutation = useMutation({
    mutationFn: updateConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendaConfig'] });
      alert('Configurações salvas com sucesso!');
    }
  });

  useEffect(() => {
    if (config) {
      reset(config);
    }
  }, [config, reset]);

  const onSubmit = (data) => {
    mutation.mutate(data);
  };

  if (isLoading) return <p className="p-8 text-center text-gray-500">Carregando configurações...</p>;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 max-w-2xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-blue-100 p-2 rounded-lg text-blue-600">
            <ShieldCheck size={24} />
        </div>
        <div>
            <h2 className="text-xl font-bold text-gray-900">Configuração do Cal.com</h2>
            <p className="text-sm text-gray-500">Integre sua conta oficial do Cal.com com o Inbase CRM.</p>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">API Key do Cal.com</label>
          <input
            type="password"
            {...register('cal_api_key')}
            placeholder="cal_live_..."
            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
          />
          <p className="mt-1 text-xs text-gray-400">Você encontra essa chave nas configurações de desenvolvedor do seu Cal.com.</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">URL da Instância (Base URL)</label>
          <input
            type="text"
            {...register('cal_base_url')}
            placeholder="https://agenda.minhainbase.com.br"
            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
          />
          <p className="mt-1 text-xs text-gray-400">Geralmente https://cal.com ou seu subdomínio personalizado.</p>
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={mutation.isPending}
            className="flex items-center justify-center gap-2 bg-primary text-white px-6 py-2 rounded-lg font-medium hover:bg-secondary transition-colors disabled:opacity-50"
          >
            <Save size={18} />
            {mutation.isPending ? 'Salvando...' : 'Salvar Configurações'}
          </button>
        </div>
      </form>
    </div>
  );
}
